import { render, staticRenderFns } from "./PasoUnoPlantilla.vue?vue&type=template&id=3704f920"
import script from "./PasoUnoPlantilla.vue?vue&type=script&lang=js"
export * from "./PasoUnoPlantilla.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports